import { render, staticRenderFns } from "./CellRendererTimestamp.vue?vue&type=template&id=525dd079&scoped=true&"
import script from "./CellRendererTimestamp.vue?vue&type=script&lang=js&"
export * from "./CellRendererTimestamp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525dd079",
  null
  
)

export default component.exports